import React, { useState, useEffect } from "react";
import { TableEditBtn, TableViewBtn, TableDeleteBtn } from '../../../images/Svgs'
import { CustomToolTip } from "../../../utils/common";

const LegalInfoList = ({ legalInfoList,onEditInfo}) => {
    return (
        <div className="">
            <div className="row">
                <div className="col-12">
                    <table className="table">
                        <thead>
                            <tr>
                                <th scope="col">Sr No.</th>
                                <th scope="col">Type</th>
                                <th scope="col">Status</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {legalInfoList && legalInfoList.length > 0 && legalInfoList?.map((item,i) => {
                                return (
                                    <tr key={item.id}>
                                         <td scope="row" className="text_capitalize">
                                             {i+1} 
                                        </td>
                                        <td scope="row" className="text_capitalize">
                                        {item?.type === "termsCondition"? "Terms & Conditions" : "Privacy Policies"}
                                        </td>
                                        <td className={`${item.is_active ? 'active' : 'deactive'}`}>{item.is_active ? 'Active' : 'Deactive'}</td>
                                        <td>
                                            <button type="button" className="btn position-relative" onClick={() => onEditInfo(item)}><TableEditBtn /><CustomToolTip type='edit' title='Legal Info' /></button>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default LegalInfoList;
